import api from './api';
import { Strategy, StrategyCreate, StrategyUpdate } from '../types/strategy';

const API_BASE_URL = '';

export const getStrategies = async (): Promise<Strategy[]> => {
  const res = await api.get(`${API_BASE_URL}/strategies`);
  return res.data;
};

export const getStrategy = async (strategyId: string): Promise<Strategy> => {
  const res = await api.get(`${API_BASE_URL}/strategies/${strategyId}`);
  return res.data;
};

export const createStrategy = async (config: StrategyCreate): Promise<Strategy> => {
  const res = await api.post(`${API_BASE_URL}/strategies`, config);
  return res.data;
};

export const updateStrategy = async (
  strategyId: string,
  updates: StrategyUpdate,
): Promise<Strategy> => {
  const res = await api.put(`${API_BASE_URL}/strategies/${strategyId}`, updates);
  return res.data;
};

export const deleteStrategy = async (strategyId: string): Promise<void> => {
  await api.delete(`${API_BASE_URL}/strategies/${strategyId}`);
};

export const toggleStrategy = async (strategyId: string, enabled: boolean): Promise<void> => {
  await api.put(`${API_BASE_URL}/strategies/${strategyId}/toggle`, null, {
    params: { enabled },
  });
};

export const seedStrategiesFromCsv = async (): Promise<{ inserted: number }> => {
  const res = await api.post(`${API_BASE_URL}/strategies/seed-csv`);
  return res.data;
};
